import { z } from 'zod';

/**
 * Public config, validated once at startup so a missing/mistyped var fails fast rather than
 * surfacing as a confusing runtime error. `VITE_API_BASE_URL` is the origin of sash-admin-api
 * (no `/api` suffix — the generated api-client hooks carry it).
 *
 * These are ordinary Vite variables: `import.meta.env` is inlined at build time, so the URL is
 * baked into the bundle and one image serves exactly one environment. Jenkins passes it per
 * branch as a Docker build arg (see `apps/portal/Dockerfile` and `docs/DEPLOYMENT.md`);
 * locally it comes from `.env`.
 */
const envSchema = z.object({
  VITE_API_BASE_URL: z.url(),
});

export type Env = z.infer<typeof envSchema>;

export const env: Env = envSchema.parse({
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
});
